<app-sales-product-general (gotoStepEvent)="onGotoStep($event)" (nextStepEvent)="onNextStep()" *ngIf="categoryCode!==Category.kredicash"/>
